export * from './define.js';
export * from './lookup.js';
export { CATALOG } from './catalog/index.js';
import { CATALOG } from './catalog/index.js';
import { indexVocabularies } from './lookup.js';
/** The one index every screen reads: `VOCABULARY.label('ride.status', code, lang)`. */
export const VOCABULARY = indexVocabularies(CATALOG);
//# sourceMappingURL=index.js.map